import Link from "@tiptap/extension-link";

const disallowedProtocols = ["ftp", "file", "mailto"];
const disallowedDomains = [
  "example-phishing.com",
  "malicious-site.net",
  "example-no-autolink.com",
  "another-no-autolink.com",
];

function isDomainAllowed(hostname) {
  return !disallowedDomains.includes(hostname);
}

function isProtocolAllowed(protocol) {
  const cleaned = protocol.replace(":", "");
  return !disallowedProtocols.includes(cleaned);
}

export const LinkExtension = Link.configure({
  openOnClick: false,
  autolink: true,
  markdownLinks: true,
  defaultProtocol: "https",
  protocols: ["http", "https"],
  isAllowedUri: (url, ctx) => {
    try {
      const parsedUrl = url.includes(":")
        ? new URL(url)
        : new URL(`${ctx.defaultProtocol}://${url}`);

      if (!ctx.defaultValidate(parsedUrl.href)) {
        return false;
      }

      const protocol = parsedUrl.protocol.replace(":", "");
      if (!isProtocolAllowed(protocol)) {
        return false;
      }

      const allowedProtocols = ctx.protocols.map((p) =>
        typeof p === "string" ? p : p.scheme,
      );
      if (!allowedProtocols.includes(protocol)) {
        return false;
      }

      if (!isDomainAllowed(parsedUrl.hostname)) {
        return false;
      }

      return true;
    } catch {
      return false;
    }
  },
  shouldAutoLink: (url) => {
    try {
      const parsedUrl = url.includes(":")
        ? new URL(url)
        : new URL(`https://${url}`);

      return isDomainAllowed(parsedUrl.hostname);
    } catch {
      return false;
    }
  },
});
